module.exports = __webpack_public_path__ + "img/trends_7.46b3325f.jpg";